import { useEffect } from 'react';
import {
  firstVirtualTourStep,
  lastVirtualTourStep,
  nextVirtualTourStep,
  previousVirtualTourStep,
  goToVirtualTourStep,
} from '../state/appState';

export function useKeyboardNavigation() {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const activeElement = document.activeElement as HTMLElement | null;
      const targetElement = (event.target as HTMLElement | null) ?? null;
      const elementToCheck = activeElement ?? targetElement;

      if (
        elementToCheck instanceof HTMLInputElement ||
        elementToCheck instanceof HTMLTextAreaElement ||
        elementToCheck instanceof HTMLSelectElement ||
        elementToCheck?.isContentEditable
      ) {
        return;
      }

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          nextVirtualTourStep();
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          previousVirtualTourStep();
          break;
        case 'Home':
          event.preventDefault();
          firstVirtualTourStep();
          break;
        case 'End':
          event.preventDefault();
          lastVirtualTourStep();
          break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9': {
          const index = Number(event.key) - 1;
          if (index >= 0) {
            event.preventDefault();
            goToVirtualTourStep({ index });
          }
          break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
